var map = {
	"./014---ExplosiveGrenade.json": 48691,
	"./015---FastGrenade.json": 45670,
	"./016---ClusterBomb.json": 20814,
	"./017---MagnetGrenade.json": 6177,
	"./018---StunningGrenade.json": 73671,
	"./019---IceBomb.json": 86678,
	"./020---FireBomb.json": 60226,
	"./021---RootBomb.json": 44299,
	"./022---OilBomb.json": 37432,
	"./023---SideBomb.json": 50912,
	"./024---Pokebomb.json": 93321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85482;